<template>
  <div class="right-home product-list">
    <div class="breadcrumb">产品列表</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="产品类别:">
              <el-select v-model="formInline.categoryId" placeholder="请选择" ref="multiSelect" clearable>
                <el-option :value="treeDataValue" style="height: auto">
                  <el-tree ref="tree" :data="categoryList" default-expand-all node-key="id" :props="defaultProps" @node-click="handNodeClick" />
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称:">
              <el-input v-model="formInline.spuName" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="上架状态:">
              <el-select v-model="formInline.isSale" placeholder="请选择" clearable>
                <el-option label="已上架" :value="1"></el-option>
                <el-option label="未上架" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品性质:">
              <el-select v-model="formInline.propertyId" placeholder="请选择" clearable>
                <el-option :label="item.propertyName" :value="item.dictCode" v-for="(item) in natureList" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="onSubmit" round>查询</el-button>
            <el-button class="search-ok" @click="createProduct('创建普通产品')" round type="primary" style="min-width: auto !important;"> 创建普通产品 </el-button>
            <el-button class="search-ok" @click="createProduct('创建套系产品')" round type="primary" style="min-width: auto !important;"> 创建套系产品 </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column label="产品ID" prop="id" min-width="10px">
          </el-table-column>
          <el-table-column prop="spuName" label="产品名称" min-width="10px">
          </el-table-column>
          <el-table-column label="产品主图" min-width="10">
            <template v-slot="scope">
              <img :src="scope.row.spuImage" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="categoryName" label="产品性质" min-width="10">
          </el-table-column>
          <el-table-column prop="propertyName" label="产品推送" min-width="10">
          </el-table-column>
          <el-table-column prop="propertyName" label="单独推送平台数量" min-width="10">
          </el-table-column>
          <el-table-column prop="isSale" label="上架状态" min-width="10">
          </el-table-column>
          <el-table-column label="操作" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue" @click="checkItem(item, scope.row)" v-for="(item, index) in scope.row.operation" :key="index"> {{ item }}<br>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import imgSrc from '@/assets/images/code.svg'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import store from '@/store'
import { spuList, categoryGet, categoryList, spuProperty } from '@/api/pms'
export default {
  name: 'product-list',
  components: {
    VPagination,
    CombinedDialog
  },
  data () {
    return {
      categoryList: [],
      natureList: [],
      treeData: '',
      treeDataValue: '',
      formInline: {
        categoryId: '',
        isSale: '',
        spuName: '',
        propertyId: ''
      },
      tableData: [],
      defaultProps: {
        // children: 'children',
        label: 'name'
      },
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  // 获取上一个页面的路由
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入fromPath
      vm.fromPath = from.path
      vm.getCookie(vm.fromPath)
      vm.getProList({
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      })
    })
  },
  created () {
    // 获取产品类
    this.getProCate()
    // 获取产品性质
    this.getProNature()
    // this.getProList(this.queryInfo)
  },
  methods: {
    // 设置cookie
    setCookie () {
      // 获取当前路由，将当前页面的路由作为name存入cookie中
      let name = this.$route.path
      // 需要存入的参数
      document.cookie = name + '=' + this.$qs.stringify(this.formInline)
    },
    // 从cookie中获取之前存入的参数
    // data为指定页面的路由，当从指定页面返回到当前页面时才到cookie中获取上一次存入的参数 。
    getCookie (data) {
      if (data === '/editpro' || data === './createsku' || data === './viewsku') {
        let name = this.$route.path
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        let arr = document.cookie.match(reg)
        // if (arr === document.cookie.match(reg)) {
        //  )
        this.formInline = this.$qs.parse(arr[2])
        if (this.formInline.propertyId !== '') {
          this.formInline.propertyId = parseInt(this.formInline.propertyId)
        }
        // }
      }
    },
    onSubmit () {
      this.getProList(this.queryInfo)
    },
    getProCate () {
      // 获取产品类
      categoryList().then((res) => {
        this.categoryList = res.data.data
      })
    },
    getProNature () {
      // 获取产品性质
      spuProperty().then((res) => {
        this.natureList = res.data.data
      })
    },
    getProList (val) {
      spuList({ pageNum: val.pageNum, pageSize: val.pageSize, spuVO: this.formInline }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].isSale === 0) {
              this.tableData[i].isSale = '未上架'
            }
            if (this.tableData[i].isSale === 1) {
              this.tableData[i].isSale = '已上架'
            }
            this.tableData[i].operation = {
              editItem: '查看/编辑产品',
              addSKU: '添加SKU组',
              checkSKU: '查看SKU组',
              delete: '删除'
            }
          }
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    checkItem (val, content) {
      this.setCookie()
      if (val === '查看/编辑产品') {
        this.$router.push({
          path: './editpro',
          query: {
            id: content.id
          }
        })
      }
      // let startupsSpu = content.startupsSpu
      let startupsSpu = false
      if (content.topCategoryId == 10) {
        startupsSpu = true
      } else {
        startupsSpu = false
      }
      if (val === '添加SKU组') {
        this.$router.push({
          path: './createsku',
          query: {
            id: content.id,
            startupsSpu: startupsSpu
          }
        })
      }
      if (val === '查看SKU组') {
        this.$router.push({
          path: './viewsku',
          query: {
            id: content.id,
            startupsSpu: startupsSpu
          }
        })
      }
      if (val === '删除') {
        this.$refs.dialogRef.show('delete', '确定提示', '删除确定<br><span style="color: #999">是否确定删除</span>', this.tableData, content.id, `/api/pms/admin/spu/delete/${content.id}`)
      }
    },
    createProduct (val) {
      if (val === '创建普通产品') {
        this.$router.push({
          path: './createPro',
          query: {
            id: 0
          }
        })
      }
      if (val === '创建套系产品') {
        this.$router.push({
          path: './createPro',
          query: {
            id: 1
          }
        })
      }
    },
    clearHandle () {
    },
    handNodeClick (data, node, nodeData) {
      if (node.childNodes.length === 0) {
        this.treeDataValue = data
        this.formInline.categoryId = data.name
        this.$refs.multiSelect.blur()
      }
    },
    changePage (val) {
      this.queryInfo = val
      this.getProList(this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
